import AboutHero from './components/AboutHero';
import CathyStory from './components/CathyStory';
import MissionVision from './components/MissionVision';
import CTASection from '@/pages/home/components/CTASection';

const AboutPage = () => {
  return (
    <main>
      <AboutHero />
      <CathyStory />
      <MissionVision />
      <CTASection />
    </main>
  );
};

export default AboutPage;
